import { Equipment } from "@/models/Product";

export const equipmentMock: Equipment[] = [
  {
    id: "eq-1",
    title: "Bose A20 Aviation Headset",
    description: "Premium ANR headset with Bluetooth connectivity. Crystal clear communication in the noisiest cockpits.",
    price: 1095,
    images: ["https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800"],
    category: "equipment",
    subcategory: "Headset-uri ANR",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2026-01-10",
    location: "București, România",
    status: "available",
    condition: "new",
    manufacturer: "Bose",
  },
  {
    id: "eq-2",
    title: "Garmin aera 760 GPS",
    description: "Portable aviation GPS with moving map, weather, and traffic. Touchscreen display.",
    price: 1899,
    images: ["https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800"],
    category: "equipment",
    subcategory: "GPS aviation",
    sellerId: "s2",
    sellerName: "EuroAvion SRL",
    createdAt: "2025-12-20",
    location: "Cluj-Napoca, România",
    status: "available",
    condition: "new",
    manufacturer: "Garmin",
  },
  {
    id: "eq-3",
    title: "BRS Aerospace Parachute System",
    description: "Whole aircraft parachute recovery system for light aircraft. Complete kit with installation hardware.",
    price: 5500,
    images: ["https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800"],
    category: "equipment",
    subcategory: "Parachutes",
    sellerId: "s3",
    sellerName: "RotorWing Romania",
    createdAt: "2025-11-05",
    location: "Timișoara, România",
    status: "available",
    condition: "new",
    manufacturer: "BRS Aerospace",
  },
  {
    id: "eq-4",
    title: "ACR ResQLink 400 PLB",
    description: "Personal locator beacon with GPS. Essential survival equipment for every pilot.",
    price: 349,
    images: ["https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800"],
    category: "equipment",
    subcategory: "ELT",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2026-02-01",
    location: "București, România",
    status: "available",
    condition: "new",
    manufacturer: "ACR Electronics",
  },
];
